import ViewModelService from './ViewModelService';
import 'gw-portals-metadata-angular';

export default angular.module('gw-portals-viewmodel-angular', ['gw-portals-metadata-angular']).factory('ViewModelService', ViewModelService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-angular/module.js
// module id = 146
// module chunks = 0